import {
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { DebugComponent } from '../debug/debug.component';
import { DropdownOptionComponent } from '../dropdown-option/dropdown-option.component';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { Indicator } from '../../../models/indicator';

@Component({
  selector: 'app-indicator-dropdown',
  standalone: true,
  imports: [
    DropdownModule,
    NgIf,
    SharedModule,
    FormsModule,
    DebugComponent,
    DropdownOptionComponent,
  ],
  templateUrl: './indicator-dropdown.component.html',
  styleUrl: './indicator-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IndicatorDropdownComponent),
      multi: true,
    },
  ],
})
export class IndicatorDropdownComponent
  implements ControlValueAccessor, OnInit
{
  readonly indicatorStore = inject(IndicatorStore);

  @Input() items!: Indicator[];
  @Input() label = 'Indikator';
  @Input() name = 'indikator';
  @Input() selection: Indicator | null = null;
  @Input() disabled = false;
  @Input() enableEmpty = false;
  @Input() isStandalone = false;
  @Output() selectionChange = new EventEmitter<Indicator>();

  touched = false;

  ngOnInit() {
    this.selection = this.selection || this.items[0];
  }

  protected onChange = (value: Indicator) => {
    setTimeout(() => {
      this.selectionChange.emit(value);
    }, 10);
  };

  private onTouched = () => {
    this.touched = false;
  };

  writeValue(value: any): void {
    this.selection = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
